/* global axios */
import ApiClient from './ApiClient';

class SharedFilesAPI extends ApiClient {
  constructor() {
    super('shared_files', { accountScoped: true });
  }

  sendFile(fileId, { conversationId }) {
    return axios.post(`${this.url}/${fileId}/send_file`, {
      conversation_id: conversationId,
    });
  }
}

export default new SharedFilesAPI();
